import { render } from "./Businesses.vue?vue&type=template&id=677f92c2"
import script from "./Businesses.vue?vue&type=script&lang=js"
export * from "./Businesses.vue?vue&type=script&lang=js"

import "./Businesses.vue?vue&type=style&index=0&id=677f92c2&lang=scss"
script.render = render

export default script